
(() => {
  const forms = [...document.querySelectorAll('.ff-buy')];
  let busy = false;
  const lock = locked => forms.forEach(form => {
    form.querySelector('button').disabled = locked || form.dataset.unavailable === 'true';
  });
  forms.forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.dataset.unavailable = String(form.querySelector('button').disabled);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || form.dataset.unavailable === 'true') return;
      busy = true;
      lock(true);
      const status = form.querySelector('[role="status"]');
      const root = window.Shopify?.routes?.root || '/';
      status.textContent = form.dataset.checking;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', body: new FormData(form), credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) {
          if (response.status !== 422) throw new Error('add_outcome_unknown');
          status.textContent = form.dataset.refused;
          busy = false;
          lock(false);
          return;
        }
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('cart_read_unavailable');
        const cart = await cartResponse.json();
        const expected = String(form.querySelector('[name="id"]').value);
        const parent = (cart.items || []).find(item => String(item.variant_id) === expected && item.quantity > 0);
        const component = (cart.items || []).find(item => String(item.variant_id) === form.dataset.component && item.quantity >= Number(form.dataset.packs));
        if (!(cart.item_count > 0 && (parent || component))) throw new Error('cart_unverified');
        window.location.assign(root + 'checkout');
      } catch {
        forms.forEach(current => {
          current.querySelector('[role="status"]').textContent = current.dataset.inspect;
          current.querySelector('.ff-inspect').hidden = false;
        });
      }
    }, true);
  });
})();
